exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#sciTable.e-grid .e-selectionbackground.e-rowcell{background-color:hsla(0,0%,100%,.05)}#sciTable.e-grid .e-row.whiteText .e-rowcell{color:#fff;font-weight:600;font-size:13px;line-height:16px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/SciChartMultiple.vue"],"names":[],"mappings":"AACA,kDACI,oCAA4C,CAC/C,AACD,6CACI,WAAY,AACZ,gBAAiB,AACjB,eAAgB,AAChB,gBAAkB,CACrB","file":"SciChartMultiple.vue","sourcesContent":["\n#sciTable.e-grid .e-selectionbackground.e-rowcell {\n    background-color: rgba(255, 255, 255, 0.05);\n}\n#sciTable.e-grid .e-row.whiteText .e-rowcell {\n    color: #fff;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 16px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1635f11c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SciChartMultiple.vue
// module id = 1633
// module chunks = 3 4 5 6 8